export const fieldLabelSx = {
  color: 'text.primary',
  fontSize: 14,
  fontWeight: 600,
  mb: 0.75,
};

export const validationErrorColor = '#C80000';

export const requiredFieldLabelSx = {
  ...fieldLabelSx,
  '& .MuiFormLabel-asterisk': {color: 'error.main'},
};

export const invalidOutlinedInputSx = {
  '&.Mui-error .MuiOutlinedInput-notchedOutline': {
    border: `1px solid ${validationErrorColor} !important`,
  },
};

export const invalidTextFieldSx = {
  '& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
    border: `1px solid ${validationErrorColor} !important`,
  },
};

export const validationErrorTextSx = {
  color: validationErrorColor,
  fontSize: '12px',
};

export const validationHelperTextSx = {
  ...validationErrorTextSx,
  fontWeight: 500,
  lineHeight: 1,
  mt: '6px',
  ml: '16px',
};

export const cardHeadingSx = {
  color: '#212121',
  fontFamily: 'Montserrat',
  fontSize: 20,
  fontWeight: 700,
  letterSpacing: 0,
  lineHeight: 1,
  textTransform: 'capitalize',
};
